export default __webpack_public_path__ + "static/media/appstore.89128b56.svg";